import { render, staticRenderFns } from "./MovieListItem.vue?vue&type=template&id=2d0c15a2&"
import script from "./MovieListItem.vue?vue&type=script&lang=js&"
export * from "./MovieListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports